import { _hmcObject } from "./hmcConfig";
import { getTranslation } from "./translations";
import { isSmartedit } from "./utils";
import { printThankYouPage } from "./registrationForm";

export let settings = {
  test: false,
  locale: "default",
  api: {
    url: "https://digital.delonghigroup.com/lib/kw/hmc/jsonp/api.php",
  },
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1200,
  },
  hmc: {
    isAdvanced: true,
    inPageResults: true,
    name: false,
    json: {
      basePath: "https://digital.delonghigroup.com/lib/kw/hmc",
      folder: "config",
      modelUrl: false,
    },
    countriesDisabled: [ // old: "IT", "AT", "ES", "PT", "DK", "SE", "GR", "NL", "BE", "PL", "CZ"
      "DE", "CH"
    ],
  },
  brand: null,
  debug: false,
  forceNoLog: false,
  form: {},
  currentPage: 0,
  previousPage: 0,
  firstPage: 0,
  lastPage: 0,
  app: {
    root: "hmc-app",
    wrapper: null,
    navigation: null,
    navigationTitle: null,
    page: null,
    navBtns: null,
    nextBtn: null,
    prevBtn: null,
    header: null,
    footer: null,
    results: null,
    resultsWrapper: null,
    registrationForm: null,
    registrationFormWrapper: null,
  },
  isAnswered: false,
  answers: [],
  question: {
    answer: {
      min: 1,
      max: 1,
    },
  },
  answersMap: {},
  visibleIfMap: {},
  visibleIfMapForCheckingAll: [],
  pageVisibleIf: [],
  qToActivate: [],
  currentAnswer: [],
  currentQuestion: null,
  questionsMap: {},
  pagesMap: [],
  themeLight: false,
  navigationLight: false,
  navigationDL: false,
  navigationDLisVisible: false,
  navigationMap: [],
  restartHMC: () => {
    _hmcObject.restartHMC();
  },
  renderResults: (u) => {
    _hmcObject.renderResults(u);
  },
  goToPage: (n, p) => {
    _hmcObject.goToPage(n, p);
  },
  scrollToTop: (h = 0) => {
    _hmcObject.scrollToTop(h);
  },
  printRegistrationForm: () => {
    _hmcObject.printRegistrationForm();
  },
  isSmartedit: () => isSmartedit(),
  registrationForm: false,
  registrationFormPrivacyMandatory: true,
  getTranslation: (t) => getTranslation(t),
  configurator: false,
  configuratorProducts: [],
  printThankYouPage: () => printThankYouPage(),
  landingPopUp: false,
};
